import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import styles from './styles.module.scss';
const { date_picker_container } = styles;

const Calendar = (props) => {
  let { startDate, endDate, dateCallback, date } = props;

  const selectDateHandler = (date) => {
    dateCallback(date);
  };

  return (
    <div className={date_picker_container}>
      <DatePicker
        dateFormat="MM/dd/yyyy"
        selected={date !== 'false' ? date : false}
        onChange={selectDateHandler}
        minDate={startDate}
        maxDate={endDate}
        placeholderText="MM/DD"
      />
    </div>
  );
};

Calendar.propTypes = {
  /**
   * Specifies the choosen calendar date
   */
  date: PropTypes.date,
  /**
   * Specifies the callback to set the calendar date
   */
  dateCallback: PropTypes.func,

  /**
   * Specifies the calendar end date
   */
  endDate: PropTypes.date,

  /**
   * Specifies the calendar start date
   */
  startDate: PropTypes.date
};

export default Calendar;
